var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmptyContent',{attrs:{"title":_vm.$t('calendar', 'Public calendar does not exist'),"description":_vm.$t('calendar', 'Maybe the share was deleted or has expired?' )},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('CalendarBlank',{attrs:{"size":20,"decorative":""}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }